import { DiagramDefinition } from "../types";

export const m011Definition: DiagramDefinition = {
  id: "M-011",
  title: "Thumbnail Generation Pipeline",
  description:
    "Automatic image thumbnail resizing using sharp (supporting JPEG, PNG, WebP, AVIF) with disk cache caching.",
  viewBox: "0 0 1150 280",
  nodes: [
    { id: "A", kind: "client", label: "Client Request", subtext: "GET ?thumb=300x300", position: [100, 120], size: [140, 46] },
    { id: "B", kind: "decision", label: "thumb param?", subtext: "Query String", position: [340, 120], size: [130, 46] },
    { id: "C", kind: "status", label: "Return Original", subtext: "Raw File", position: [340, 220], size: [135, 45], statusColor: "#38bdf8" },
    { id: "D", kind: "decision", label: "Cached?", subtext: "Check Thumb Dir", position: [580, 120], size: [140, 46] },
    { id: "E", kind: "status", label: "Return Cached", subtext: "Fast Cache Hit", position: [820, 220], size: [120, 42], statusColor: "#ff5a1f" },
    { id: "F", kind: "service", label: "sharp.resize", subtext: "Dynamic Resizer", position: [820, 120], size: [130, 46] },
    { id: "G", kind: "service", label: "Save Cache", subtext: "Disk Write", position: [1060, 120], size: [120, 46] },
  ],
  edges: [
    { id: "e1", source: "A", target: "B", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "B", target: "C", label: "No", sourcePort: "bottom", targetPort: "top", routing: "straight" },
    { id: "e3", source: "B", target: "D", label: "Yes", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e4", source: "D", target: "E", label: "Yes", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e5", source: "D", target: "F", label: "No", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e6", source: "F", target: "G", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e7", source: "G", target: "E", sourcePort: "bottom", targetPort: "right", routing: "orthogonal" },
  ],
};
